import React, { useState } from 'react'
import styled from 'styled-components';
import { injectIntl } from 'gatsby-plugin-intl';
import { TextBtn } from "./styledComponents1";
import { device } from "./device";

import {SlideDown} from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'

const AsideBlock = styled.aside`
    display: none;
    @media ${device.lg} {
        background: #fff;
        display: block;
        position: sticky;
        top: 56px;
        max-height: calc(100vh - 56px);
        height: auto;
        width: 300px;
        transform: translate(0,0);
        transition: 0;
        
        -webkit-overflow-scrolling: touch;
        overflow-y: auto;
        overscroll-behavior: contain;
        
        &::-webkit-scrollbar {
            width: 12px;
        }

        ::-webkit-scrollbar-track,
        ::-webkit-scrollbar-thumb {
            border: 4px solid rgba(255,255,255,0);
            background-clip: padding-box;
        }

        &::-webkit-scrollbar-thumb {
            background-color: var(--light-gray3);
            border-radius: 4px;
        }
        &::-webkit-scrollbar-button {
            width: 0;
            height: 0;
            display: none;
        }
    }
    @media ${device.xl} {
        width: 320px;
    }
`;
const Nav = styled.nav`
    padding: 64px 0;
`;
const MenuList = styled.ul`
    list-style: none;
    margin: 0;
    padding-left: 0;
`;
const Item = styled.li`
    overflow: hidden;
`;
const SubMenu = styled.ul`
    list-style: none;
    margin: 0;
    padding-left: 24px;
`;
const SubItem = styled.li`
    button {
        color: var(--midle-gray1);
    }
`;

const Menu = ({ intl, handleCLick }) => {

    const [subMenu, setSubMenu] = useState({
        menu0: true,
        menu1: true,
        menu2: true,
        menu3: true,
        menu4: true,
        menu5: true,
        menu6: true,
        menu7: true,
        menu8: true,
        menu9: true
    });

    function closeAll() {
        setSubMenu({
            menu0: true,
            menu1: true,
            menu2: true,
            menu3: true,
            menu4: true,
            menu5: true,
            menu6: true,
            menu7: true,
            menu8: true,
            menu9: true
        });
    }

    return (
        <AsideBlock>
            <Nav>
                <MenuList>
                    <Item>
                        <TextBtn 
                            key='brandBlockMenu'
                            data-parent="brand-section"
                            onClick={() => {
                                if (!subMenu.menu1) {
                                    closeAll();
                                } else {
                                    handleCLick('brandSection');
                                    setSubMenu({ 
                                        menu0: false,
                                        menu1: true,
                                        menu2: true,
                                        menu3: true,
                                        menu4: true,
                                        menu5: true,
                                        menu6: true,
                                        menu7: true,
                                        menu8: true,
                                        menu9: true
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'brand_title' })}</TextBtn>
                        <SlideDown closed={subMenu.menu0}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='mentionBrandMenu'
                                        data-anchorid="mention-brand"
                                        onClick={() => handleCLick('mentionBrandBlock')}>{intl.formatMessage({ id: 'brand_1_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='differentiateBrandMenu'
                                        data-anchorid="differentiate-brand"
                                        onClick={() => handleCLick('differentiateBrandBlock')}>{intl.formatMessage({ id: 'brand_2_1' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            key='productTalkBlockMenu'
                            data-parent="productTalk-section"
                            onClick={() => {
                                closeAll();
                                handleCLick('productTalkSection');
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'productTalk_title' })}</TextBtn>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="logo-section"
                            className={'parent'}
                            onClick={() => {
                                if (!subMenu.menu1) {
                                    closeAll();
                                } else {
                                    handleCLick('logoSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: false,
                                        menu2: true,
                                        menu3: true,
                                        menu4: true,
                                        menu5: true,
                                        menu6: true,
                                        menu7: true,
                                        menu8: true,
                                        menu9: true
                                    });
                                }
                            }}>{intl.formatMessage({ id: 'MainMenu_1' })}</TextBtn>
                        <SlideDown closed={subMenu.menu1}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='logoMainMenu'
                                        data-anchorid="logo-main"
                                        onClick={() => handleCLick('logoMain')}>{intl.formatMessage({ id: 'logo_main_title' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='logoAdditionalMenu'
                                        data-anchorid="logo-additional"
                                        onClick={() => handleCLick('logoAdditional')}>{intl.formatMessage({ id: 'logo_additional_title' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='logoTaglineMenu'
                                        data-anchorid="logo-tagline"
                                        onClick={() => handleCLick('logoTagline')}>{intl.formatMessage({ id: 'logo_tagline_title' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='logoPartnershipsMenu'
                                        data-anchorid="logo-partnerships"
                                        onClick={() => handleCLick('logoPartnerships')}>{intl.formatMessage({ id: 'logo_partner_title' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='logoTagMenu'
                                        data-anchorid="logo-tag"
                                        onClick={() => handleCLick('logoTag')}>{intl.formatMessage({ id: 'logo_partner_2_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='logoTechnologiesMenu'
                                        data-anchorid="logo-technologies"
                                        onClick={() => handleCLick('logoTechnologies')}>{intl.formatMessage({ id: 'logo_technology_title' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='logoApplicationsMenu'
                                        data-anchorid="logo-applications"
                                        onClick={() => handleCLick('logoApplications')}>{intl.formatMessage({ id: 'logo_apps_title' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="color-section"
                            onClick={() => {
                                if (!subMenu.menu2) {
                                    closeAll()
                                } else {
                                    handleCLick('colorSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: true,
                                        menu2: false,
                                        menu3: true,
                                        menu4: true,
                                        menu5: true,
                                        menu6: true,
                                        menu7: true,
                                        menu8: true,
                                        menu9: true
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'MainMenu_2' })}</TextBtn>
                        <SlideDown closed={subMenu.menu2}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='colorProportionMenu'
                                        data-anchorid="color-proportion"
                                        onClick={() => handleCLick('colorProportion')}>{intl.formatMessage({ id: 'color_proportions' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='colorMainMenu'
                                        data-anchorid="color-main"
                                        onClick={() => handleCLick('colorMain')}>{intl.formatMessage({ id: 'color_title' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='colorAdditionalMenu'
                                        data-anchorid="color-additional"
                                        onClick={() => handleCLick('colorAdditional')}>{intl.formatMessage({ id: 'color_additional_title' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            key='typographyBlockMenu'
                            data-parent="typography-section"
                            onClick={() => {
                                closeAll();
                                handleCLick('typographySection');
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'MainMenu_3' })}</TextBtn>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="devices-section"
                            onClick={() => {
                                if (!subMenu.menu3) {
                                    closeAll()
                                } else {
                                    handleCLick('devicesSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: true,
                                        menu2: true,
                                        menu3: false,
                                        menu4: true,
                                        menu5: true,
                                        menu6: true,
                                        menu7: true,
                                        menu8: true,
                                        menu9: true
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'MainMenu_4' })}</TextBtn>
                        <SlideDown closed={subMenu.menu3}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='devicesUsageMenu'
                                        data-anchorid="devices-usage"
                                        onClick={() => handleCLick('devicesUsage')}>{intl.formatMessage({ id: 'devices_2_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='devicesProportionMenu'
                                        data-anchorid="devices-proportion"
                                        onClick={() => handleCLick('devicesProportion')}>{intl.formatMessage({ id: 'devices_3_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='devicesNamingMenu'
                                        data-anchorid="devices-naming"
                                        onClick={() => handleCLick('devicesNaming')}>{intl.formatMessage({ id: 'devices_4_1' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="works-section"
                            onClick={() => {
                                if (!subMenu.menu4) {
                                    closeAll()
                                } else {
                                    handleCLick('worksSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: true,
                                        menu2: true,
                                        menu3: true,
                                        menu4: false,
                                        menu5: true,
                                        menu6: true,
                                        menu7: true,
                                        menu8: true,
                                        menu9: true
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'MainMenu_6' })}</TextBtn>
                        <SlideDown closed={subMenu.menu4}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='postersBlockMenu'
                                        data-anchorid="posters"
                                        onClick={() => handleCLick('postersBlock')}>{intl.formatMessage({ id: 'work_1_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='printedMaterialsMenu'
                                        data-anchorid="printed-materials"
                                        onClick={() => handleCLick('printedMaterials')}>{intl.formatMessage({ id: 'work_2_1' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="merch-section"
                            onClick={() => {
                                if (!subMenu.menu5) {
                                    closeAll()
                                } else {
                                    handleCLick('merchSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: true,
                                        menu2: true,
                                        menu3: true,
                                        menu4: true,
                                        menu5: false,
                                        menu6: true,
                                        menu7: true,
                                        menu8: true,
                                        menu9: true
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'MainMenu_7' })}</TextBtn>
                        <SlideDown closed={subMenu.menu5}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='tshirtsBlockMenu'
                                        data-anchorid="t-shirts"
                                        onClick={() => handleCLick('tshirtsBlock')}>{intl.formatMessage({ id: 'merch_1_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='capsBlockMenu'
                                        data-anchorid="caps"
                                        onClick={() => handleCLick('capsBlock')}>{intl.formatMessage({ id: 'merch_1_2' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='cupsBlockMenu'
                                        data-anchorid="cups"
                                        onClick={() => handleCLick('cupsBlock')}>{intl.formatMessage({ id: 'merch_1_3' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='bitsBlockMenu'
                                        data-anchorid="bits"
                                        onClick={() => handleCLick('bitsBlock')}>{intl.formatMessage({ id: 'merch_1_4' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='tapeBlockMenu'
                                        data-anchorid="tape"
                                        onClick={() => handleCLick('tapeBlock')}>{intl.formatMessage({ id: 'merch_1_5' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='bagBlockMenu'
                                        data-anchorid="bag"
                                        onClick={() => handleCLick('bagBlock')}>{intl.formatMessage({ id: 'merch_1_6' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="equipment-section"
                            onClick={() => {
                                if (!subMenu.menu6) {
                                    closeAll()
                                } else {
                                    handleCLick('equipmentSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: true,
                                        menu2: true,
                                        menu3: true,
                                        menu4: true,
                                        menu5: true,
                                        menu6: false,
                                        menu7: true,
                                        menu8: true,
                                        menu9: true
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'MainMenu_8' })}</TextBtn>
                        <SlideDown closed={subMenu.menu6}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='wallStandsBlockMenu'
                                        data-anchorid="wall-stands"
                                        onClick={() => handleCLick('wallStandsBlock')}>{intl.formatMessage({ id: 'stand_1_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='lstandBlockMenu'
                                        data-anchorid="l-stand"
                                        onClick={() => handleCLick('lstandBlock')}>{intl.formatMessage({ id: 'stand_1_2' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='standsBlockMenu'
                                        data-anchorid="stands"
                                        onClick={() => handleCLick('standsBlock')}>{intl.formatMessage({ id: 'stand_1_4' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="design-section"
                            onClick={() => {
                                if (!subMenu.menu8) {
                                    closeAll()
                                } else {
                                    handleCLick('designSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: true,
                                        menu2: true,
                                        menu3: true,
                                        menu4: true,
                                        menu5: true,
                                        menu6: true,
                                        menu7: true,
                                        menu8: false,
                                        menu9: true
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'MainMenu_10' })}</TextBtn>
                        <SlideDown closed={subMenu.menu8}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='designHierarchyMenu'
                                        data-anchorid="design-hierarchy"
                                        onClick={() => handleCLick('designHierarchy')}>{intl.formatMessage({ id: 'design_1_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='designMessageMenu'
                                        data-anchorid="design-message"
                                        onClick={() => handleCLick('designMessage')}>{intl.formatMessage({ id: 'design_2_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='designConsiderMenu'
                                        data-anchorid="design-consider"
                                        onClick={() => handleCLick('designConsider')}>{intl.formatMessage({ id: 'design_3_1' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="designConstructor-section"
                            onClick={() => {
                                if (!subMenu.menu9) {
                                    closeAll()
                                } else {
                                    handleCLick('designConstructorSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: true,
                                        menu2: true,
                                        menu3: true,
                                        menu4: true,
                                        menu5: true,
                                        menu6: true,
                                        menu7: true,
                                        menu8: true,
                                        menu9: false,
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'designConstr_title' })}</TextBtn>
                        <SlideDown closed={subMenu.menu9}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='designComponentsMenu'
                                        data-anchorid="design-components"
                                        onClick={() => handleCLick('designComponents')}>{intl.formatMessage({ id: 'designConstr_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='designLayoutsMenu'
                                        data-anchorid="design-layouts"
                                        onClick={() => handleCLick('designLayouts')}>{intl.formatMessage({ id: 'designConstr_6_1' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                    <Item>
                        <TextBtn 
                            data-parent="icons-section"
                            onClick={() => {
                                if (!subMenu.menu7) {
                                    closeAll()
                                } else {
                                    handleCLick('iconsSection');
                                    setSubMenu({ 
                                        menu0: true,
                                        menu1: true,
                                        menu2: true,
                                        menu3: true,
                                        menu4: true,
                                        menu5: true,
                                        menu6: true,
                                        menu7: false,
                                        menu8: true,
                                        menu9: true
                                    });
                                }
                            }}
                            className={'parent'}>{intl.formatMessage({ id: 'MainMenu_9' })}</TextBtn>
                        <SlideDown closed={subMenu.menu7}>
                            <SubMenu>
                                <SubItem>
                                    <TextBtn 
                                        key='generalIconsMenu'
                                        data-anchorid="general-icons"
                                        onClick={() => handleCLick('generalIcons')}>{intl.formatMessage({ id: 'icons_1' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='appIconsMenu'
                                        data-anchorid="app-icons"
                                        onClick={() => handleCLick('appIcons')}>{intl.formatMessage({ id: 'icons_2' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='cloudIconsMenu'
                                        data-anchorid="cloud-icons"
                                        onClick={() => handleCLick('cloudIcons')}>{intl.formatMessage({ id: 'icons_3' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='jewellerIconsMenu'
                                        data-anchorid="jeweller-icons"
                                        onClick={() => handleCLick('jewellerIcons')}>{intl.formatMessage({ id: 'icons_4' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='centralIconsMenu'
                                        data-anchorid="central-icons"
                                        onClick={() => handleCLick('centralIcons')}>{intl.formatMessage({ id: 'icons_5' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='motionIconsMenu'
                                        data-anchorid="motionprotect-icons"
                                        onClick={() => handleCLick('motionIcons')}>{intl.formatMessage({ id: 'icons_6' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='buttonIconsMenu'
                                        data-anchorid="button-icons"
                                        onClick={() => handleCLick('buttonIcons')}>{intl.formatMessage({ id: 'icons_7' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='doorIconsMenu'
                                        data-anchorid="doorprotect-icons"
                                        onClick={() => handleCLick('doorIcons')}>{intl.formatMessage({ id: 'icons_8' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='glassIconsMenu'
                                        data-anchorid="glassprotect-icons"
                                        onClick={() => handleCLick('glassIcons')}>{intl.formatMessage({ id: 'icons_9' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='fireIconsMenu'
                                        data-anchorid="fireprotect-icons"
                                        onClick={() => handleCLick('fireIcons')}>{intl.formatMessage({ id: 'icons_10' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='leaksIconsMenu'
                                        data-anchorid="leaks-icons"
                                        onClick={() => handleCLick('leaksIcons')}>{intl.formatMessage({ id: 'icons_11' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='spaceIconsMenu'
                                        data-anchorid="spacecontrol-icons"
                                        onClick={() => handleCLick('spaceIcons')}>{intl.formatMessage({ id: 'icons_12' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='keypadIconsMenu'
                                        data-anchorid="keypad-icons"
                                        onClick={() => handleCLick('keypadIcons')}>{intl.formatMessage({ id: 'icons_13' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='sirenIconsMenu'
                                        data-anchorid="siren-icons"
                                        onClick={() => handleCLick('sirenIcons')}>{intl.formatMessage({ id: 'icons_14' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='automationIconsMenu'
                                        data-anchorid="automation-icons"
                                        onClick={() => handleCLick('automationIcons')}>{intl.formatMessage({ id: 'icons_15' })}</TextBtn>
                                </SubItem>
                                <SubItem>
                                    <TextBtn 
                                        key='intagrationIconsMenu'
                                        data-anchorid="intagration-icons"
                                        onClick={() => handleCLick('intagrationIcons')}>{intl.formatMessage({ id: 'icons_16' })}</TextBtn>
                                </SubItem>
                            </SubMenu>
                        </SlideDown>
                    </Item>
                </MenuList>
            </Nav>
        </AsideBlock>
    )
}

export default injectIntl(Menu);
